export interface CapturedTrackingParams {
  sourcePage: string;
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
}

/**
 * Auto-captured hidden fields (09-landing-page.md §3 "not shown to the user") — read from the
 * *browser's* actual URL at submit time, not from react-router's location (prerendering never has
 * a real query string, and this only ever needs to run client-side on submit anyway).
 * `typeof window === 'undefined'` guards the SSG build pass, which never calls this.
 */
export function captureTrackingParams(
  pathname: string,
): CapturedTrackingParams {
  if (typeof window === "undefined") {
    return {
      sourcePage: pathname,
      utmSource: null,
      utmMedium: null,
      utmCampaign: null,
    };
  }
  const params = new URLSearchParams(window.location.search);
  return {
    sourcePage: pathname,
    utmSource: params.get("utm_source"),
    utmMedium: params.get("utm_medium"),
    utmCampaign: params.get("utm_campaign"),
  };
}
